#import "../../../../../../../common/graphql/EntityDocumentsFields.graphql"

query TASupplierDetails($id: UUID!) {
  supplier(id: $id) {
    id
    _isAliasInvoked
    _isAliasOriginalNameViewable
    _isUpdatable
    _isDeletable
    _rowTimestamp
    _isPurchaseOrderSettingsUpdatable
    companyOrLastName
    federalTaxReference
    vatNumber
    firstName
    _isStagedApprovalRequest
    _isApprovalRevocable
    _requiredApprovalDocuments
    _isApprovalDocumentsRequired
    isRelatedPartySupplier
    isCompetitiveBidsRequired
    isContractualPurchaseOrderRequired
    isDraft
    isIndividual
    isCorporation
    vendorServiceRate
    statusType {
      statusType
    }
    supplierAddressesBySupplierId {
      nodes {
        id
        _rowTimestamp
        addressLine1
        addressLine2
        cityName
        countryId
        stateRegionId
        postalCode
        telephoneNumber
        emailAddress
        webAddress
        isSendEmailAccount
        isPrimary
      }
    }
    supplierRatingResults {
      id
      countTotal
      starValue
      star1Percent
      star2Percent
      star3Percent
      star4Percent
      star5Percent
    }
    supplierHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
        tenantUserName
      }
    }
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
      totalCount
    }
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _tagBadgeColor
        _rowTimestamp
      }
    }
  }
}
